import React from "react";
import { DEADLINE_META } from "@/lib/api";
import { Clock, AlertTriangle, CheckCircle2, XCircle, MinusCircle } from "lucide-react";

const TONES = {
  ok: "bg-emerald-50 text-emerald-700 border-emerald-200",
  warn: "bg-amber-50 text-amber-700 border-amber-200",
  urgent: "bg-orange-50 text-orange-700 border-orange-200",
  passed: "bg-red-50 text-red-700 border-red-200",
  muted: "bg-slate-50 text-slate-500 border-slate-200",
};

const ICONS = { ok: CheckCircle2, warn: Clock, urgent: AlertTriangle, passed: XCircle, muted: MinusCircle };

function daysHint(status, days) {
  if (days == null) return "";
  if (status === "passed") {
    const over = Math.max(0, Math.floor(-days));
    return over >= 1 ? `${over}d overdue` : "overdue";
  }
  if (days < 1) {
    const hrs = Math.max(0, Math.floor(days * 24));
    return hrs <= 0 ? "<1h left" : `${hrs}h left`;
  }
  return `${Math.floor(days)}d left`;
}

// Shows a plain-language deadline risk badge. Set hideLowRisk to skip on_track / no_deadline.
export function DeadlineBadge({ status, days, hideLowRisk = false, className = "" }) {
  const isLow = !status || status === "on_track" || status === "no_deadline";
  if (hideLowRisk && isLow) return null;
  const meta = DEADLINE_META[status] || DEADLINE_META.no_deadline;
  const Icon = ICONS[meta.tone];
  const hint = daysHint(status, days);
  const pulse = status === "urgent" || status === "passed";
  return (
    <span
      data-testid={`deadline-badge-${status || "no_deadline"}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold ${TONES[meta.tone]} ${pulse ? "pulse-dot" : ""} ${className}`}
    >
      <Icon className="h-3 w-3" />
      {meta.label}{hint ? ` · ${hint}` : ""}
    </span>
  );
}
